import {
  Box,
  PanelSection,
  type PanelSectionProps,
} from '@dev-spendesk/grapes';
import React, { type ReactElement, type ReactNode } from 'react';

type Props = DistributiveOmit<PanelSectionProps, 'children'> & {
  previews: ReactElement[];
  noPreviewContent: string;
  children?: ReactNode;
  beforePreviews?: ReactNode;
};

export function PanelPreviewsSection({
  previews,
  noPreviewContent,
  children,
  beforePreviews,
  ...panelSectionProps
}: Props) {
  return (
    <PanelSection {...panelSectionProps}>
      <>
        {beforePreviews ? <div className="mb-8">{beforePreviews}</div> : null}

        {previews.length === 0 ? (
          <Box
            variant="secondary"
            className="border border-dashed border-border-default px-64 py-16 text-center text-content-secondary-bg-secondary"
          >
            {noPreviewContent}
          </Box>
        ) : (
          <div className="flex flex-col gap-8">{previews}</div>
        )}
        {children}
      </>
    </PanelSection>
  );
}
